export default __webpack_public_path__ + "static/media/compiegne6.f5d140a9.jpg";